import { render, staticRenderFns } from "./Webhook.vue?vue&type=template&id=b5f7612a"
import script from "./Webhook.vue?vue&type=script&lang=js"
export * from "./Webhook.vue?vue&type=script&lang=js"
import style0 from "./Webhook.vue?vue&type=style&index=0&id=b5f7612a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports